import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'tix-back-button',
  template: `<button
    (click)="goBack()"
    matTooltip="Back"
    mat-icon-button
    class="border border-primary bg-white hover:bg-primary-50 rounded-full"
  >
    <span class="material-icons text-primary">arrow_back</span>
  </button>`
})
export class TixBackButtonComponent {
  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
